module.exports = __webpack_public_path__ + "img/12.1d425b77.png";